import { render, staticRenderFns } from "./ResellerList.vue?vue&type=template&id=1445d510&scoped=true&"
import script from "./ResellerList.vue?vue&type=script&lang=js&"
export * from "./ResellerList.vue?vue&type=script&lang=js&"
import style0 from "./ResellerList.vue?vue&type=style&index=0&id=1445d510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1445d510",
  null
  
)

export default component.exports